import React, { useState } from 'react';
import { Lock } from 'lucide-react';
import { adminLogin } from './adminApi';

const inputClass = 'w-full border border-gray-300 bg-white px-4 py-3 text-base focus:border-gray-900 focus:outline-none';

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await adminLogin(email.trim(), password);
      onLogin(data.token);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center px-6 py-16">
      <form onSubmit={handleSubmit} className="w-full max-w-md border border-gray-200 bg-white p-8 sm:p-12" data-testid="admin-login-form">
        <Lock className="mb-6 h-6 w-6" aria-hidden="true" />
        <p className="mb-2 text-xs font-bold uppercase tracking-widest text-gray-500">3D Printer Gear</p>
        <h1 className="mb-8 text-3xl font-bold tracking-tight">Admin sign in</h1>
        <label htmlFor="admin-email" className="mb-2 block text-sm font-bold">Email</label>
        <input id="admin-email" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className={`${inputClass} mb-6`} data-testid="admin-login-email-input" />
        <label htmlFor="admin-password" className="mb-2 block text-sm font-bold">Password</label>
        <input id="admin-password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} className={`${inputClass} mb-6`} data-testid="admin-login-password-input" />
        {error && <p role="alert" className="mb-6 border-l-4 border-red-600 bg-red-50 px-4 py-3 text-sm text-red-800" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} className="w-full bg-gray-900 px-8 py-4 text-sm font-bold text-white transition-colors hover:bg-black disabled:opacity-60" data-testid="admin-login-submit-button">
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </main>
  );
};
